import styled, { css } from 'styled-components';
import { readableColor } from 'polished';
import { fontTitle } from 'Styles/fonts';
import readableText from 'Styles/readable-text';
import * as colors from 'Styles/colors';
import breakpoint from 'Styles/breakpoints';
import { Button as StyledButton } from '../Button/Button.styled';

export const CTABlock = styled.div`
  /* Offsets the right margin on each individual CTA when block is centered */
  margin-right: -8px;
  ${({ $isCentered }) =>
    $isCentered &&
    css`
      text-align: center;
    `}

  ${({ $stackOnSmall }) =>
    $stackOnSmall &&
    css`
      display: grid;
      grid-template-columns: max-content;
      grid-gap: 4px 0px;
      ${({ $isCentered }) =>
        $isCentered &&
        css`
          justify-content: center;
        `}

      ${breakpoint('medium')} {
        display: block;
      }
    `}
`;

export const CTA = styled(StyledButton)`
  ${fontTitle()}
  line-height: 40px;
  margin: 0 8px 8px 0;

  ${({ $backgroundColor }) => {
    if ($backgroundColor) {
      const backgroundColor = readableColor($backgroundColor);
      return readableText(backgroundColor);
    }
  }};
`;

export const Overflow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  margin-top: 8px;
  -webkit-overflow-scrolling: auto;
  /* Hide scrollbar in FF */
  scrollbar-width: none;
  /* Hide scrollbar in chrome/safari */
  ::-webkit-scrollbar {
    display: none;
  }

  /** Padding goes in pseudo elements so that overflow space in Safari renders as expected  */
  /** Otherwise buttons will scroll to the edge of the screen */
  &::before {
    content: '';
    height: 1px;
    padding-left: ${({ $overflowOffset }) => $overflowOffset || '16px'};
    margin: auto;
  }

  &::after {
    content: '';
    height: 1px;
    padding-right: ${({ $overflowOffset }) => $overflowOffset || '16px'};
    margin: auto;
  }

  /* Prevents CTA from wrapping so they can overflow in container */
  & ${CTA} {
    white-space: nowrap;
  }

  & ${CTA}:last-of-type {
    border-right: ${({ $backgroundColor }) =>
      `16px ${colors[$backgroundColor]} solid;`};
  }
`;
